(() => {
  // ✅ Solo corre en /products/
  if (!location.pathname.includes("/products/")) return;

  console.log("[personalizado] image-swap listo ✅");

  // ✅ Base de Shopify Files (CDN)
  const FILES_BASE_URL =
    "https://cdn.shopify.com/s/files/1/0648/2093/6921/files/";

  // ✅ Normaliza para que coincida con tus nombres: rojo_cafe.webp, limon_rosa.webp, etc.
  const norm = (s) =>
    (s || "")
      .toString()
      .trim()
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "") // acentos
      .replace(/\*/g, "") // asteriscos
      .replace(/[^\w\s-]/g, "") // símbolos raros
      .replace(/\s+/g, "_"); // espacios -> _

  // ✅ Encuentra la imagen principal (varía según el theme/galería)
  function getMainImgEl() {
    const selectors = [
      ".media-gallery .is-active img",
      ".media-gallery__viewer img",
      ".product__media img",
      ".product-media img",
      ".product-gallery img",
      ".product__media-item.is-active img",
      ".product__media-wrapper img",
      ".product__media-list img",
      "main img",
    ];

    for (const sel of selectors) {
      const el = document.querySelector(sel);
      if (el && el.src) return el;
    }
    return null;
  }

  // ✅ Quita srcset/sizes para que el theme no “revierta” el cambio
  function clearSrcsetAround(img) {
    if (!img) return;

    img.removeAttribute("srcset");
    img.removeAttribute("sizes");

    const picture = img.closest("picture");
    if (picture) {
      picture.querySelectorAll("source").forEach((s) => {
        s.removeAttribute("srcset");
        s.removeAttribute("sizes");
      });
    }
  }

  function tryLoad(url) {
    return new Promise((resolve) => {
      const im = new Image();
      im.onload = () => resolve(true);
      im.onerror = () => resolve(false);
      im.src = url;
    });
  }

  // ✅ Encuentra el valor seleccionado en un UL (robusto para PC Product Options)
  function getSelectedValueFromUl(ul) {
    if (!ul) return null;

    // 1) Si el input realmente se marca como checked
    const checked = ul.querySelector("input:checked");
    if (checked) return checked.value || checked.getAttribute("value") || null;

    // 2) PC Options suele marcar el <li> con class "selected"
    const liSelected = ul.querySelector("li.selected");
    if (liSelected) {
      const input = liSelected.querySelector("input");
      const v = input?.value || input?.getAttribute?.("value");
      if (v) return v;
      // fallback: texto
      const t = liSelected.textContent?.trim();
      if (t) return t;
    }

    // 3) Fallbacks por ARIA (a veces usan esto)
    const liAria = ul.querySelector('li[aria-selected="true"], li[aria-checked="true"]');
    if (liAria) {
      const input = liAria.querySelector("input");
      const v = input?.value || input?.getAttribute?.("value");
      if (v) return v;
      const t = liAria.textContent?.trim();
      if (t) return t;
    }

    // 4) Si usan botones
    const btnPressed = ul.querySelector('button[aria-pressed="true"], [role="button"][aria-pressed="true"]');
    if (btnPressed) {
      const v =
        btnPressed.getAttribute("data-value") ||
        btnPressed.getAttribute("aria-label") ||
        btnPressed.getAttribute("title") ||
        btnPressed.textContent;
      if (v) return v.trim();
    }

    return null;
  }

  // ✅ Lee selecciones de TODAS las opciones dentro de PC Product Options
  function getSelectedValues() {
    // Importante: limitamos al wrapper de PC Options (pero soportamos múltiples wrappers)
    const uls = Array.from(
      document.querySelectorAll('.product-customizer-upswatch-wrapper ul[id*="_option_"]')
    );

    const values = [];
    for (const ul of uls) {
      const raw = getSelectedValueFromUl(ul);
      const v = norm(raw);
      if (v) values.push(v);
    }

    return values;
  }

  // ✅ Tus archivos están en RAÍZ (/files/rojo_cafe.webp). Generamos candidatos SOLO raíz (+ invertido)
  function buildCandidateUrls(parts) {
    const key = parts.join("_"); // limon_rosa
    const file = encodeURIComponent(`${key}.webp`);
    const bust = `?v=${Date.now()}`; // evita caché terca

    const urls = [
      FILES_BASE_URL + file,
      FILES_BASE_URL + file + bust
    ];

    // Si son 2 opciones, intenta invertido también
    if (parts.length === 2) {
      const invKey = `${parts[1]}_${parts[0]}`;
      const invFile = encodeURIComponent(`${invKey}.webp`);
      urls.push(FILES_BASE_URL + invFile);
      urls.push(FILES_BASE_URL + invFile + bust);
    }

    return urls;
  }

  let lastApplied = "";

  async function applySwap() {
    const parts = getSelectedValues();

    // ✅ Debug útil (para que veas qué está leyendo)
    console.log("[personalizado] seleccion detectada:", parts);

    // Necesitamos mínimo 2 selecciones (color 1 + color 2)
    if (parts.length < 2) return;

    const signature = parts.join("|");
    if (signature === lastApplied) return;

    const candidates = buildCandidateUrls(parts);

    let chosen = null;
    for (const url of candidates) {
      // eslint-disable-next-line no-await-in-loop
      const ok = await tryLoad(url);
      if (ok) {
        chosen = url;
        break;
      }
    }

    if (!chosen) {
      console.warn("[personalizado] No encontré imagen para:", parts, candidates);
      return;
    }

    const img = getMainImgEl();
    if (!img) {
      console.warn("[personalizado] No encontré la imagen principal para reemplazar.");
      return;
    }

    clearSrcsetAround(img);
    img.src = chosen;

    lastApplied = signature;
    console.log("[personalizado] ✅ Imagen cambiada a:", chosen);
  }

  function bind() {
    // 1) change global (PC Options a veces dispara change)
    document.addEventListener("change", () => setTimeout(applySwap, 80), true);

    // 2) click global (PC Options muchas veces es click + clase selected)
    document.addEventListener("click", () => setTimeout(applySwap, 120), true);

    // 3) MutationObserver (por si actualiza DOM sin eventos)
    const mo = new MutationObserver(() => setTimeout(applySwap, 120));
    mo.observe(document.body, { subtree: true, attributes: true, childList: true });

    // intento inicial
    setTimeout(applySwap, 600);

    console.log("[personalizado] Observadores activos ✅");
  }

  bind();
})();